import style from "./style.scss";

import Center from "../../../components/center";
import Editorial from "../../../components/editorial";
import Head from "../../../components/head";
import Hero from "../../../components/hero";
import Ligature from "../../../components/ligature";
import NoWrap from "../../../components/no-wrap";
import DownloadItem from "../../../components/download-item";

const pageTitle = "2025 - Downloads - Klahanie.info";

const Downloads = () => (
  <div>
    <Head title={pageTitle} />
    <Hero background="/images/backgrounds/forest-path.jpg">
      <h1>
        <span style="font-size: 0.5em; font-weight: 400; display: block; margin-bottom: 0.25em; text-transform: none;">
          2025{" "}
        </span>
        <Ligature>Downloads</Ligature>
      </h1>
      <h2>
        <span>
          <NoWrap>"Your Voice,</NoWrap> <NoWrap>Our Promise"</NoWrap>
        </span>
      </h2>
    </Hero>
    <Editorial>
      <Center>
        <div class={style.downloads}>
          <ul>
            <li>
              <DownloadItem
                title="Flyer Front"
                files={[
                  { name: "Yellow", file: "/downloads/flyer-yellow.pdf" },
                  { name: "White", file: "/downloads/flyer-white.pdf" },
                ]}
                image="/downloads/flyer-yellow.png"
              />
            </li>
            <li>
              <DownloadItem
                title="Flyer Back"
                file="/downloads/flyer-back.pdf"
                image="/downloads/flyer-back.png"
              />
            </li>
            <li>
              <DownloadItem
                title="Social Small"
                file="/downloads/social-small.png"
                image="/downloads/social-small.png"
              />
            </li>
            <li>
              <DownloadItem
                title="Social Medium"
                file="/downloads/social-medium.png"
                image="/downloads/social-medium.png"
              />
            </li>
            <li>
              <DownloadItem
                title="Social Large"
                file="/downloads/social-large.png"
                image="/downloads/social-large.png"
              />
            </li>
            {/* <li>
              <DownloadItem
                title="Jim's Letter"
                file="/downloads/jims-letter.pdf"
                image="/downloads/jims-letter.png"
              />
            </li> */}
          </ul>
        </div>
      </Center>
    </Editorial>
  </div>
);

export default Downloads;
